import {
  IDependentsByFileToUpload,
  IDependentsWithErrors
} from '../../../../../../shared/interfaces/manageCollaborators';

export const mapDependentsByFileDataToDependentsByFileToUpload = (
  member: IDependentsWithErrors
): IDependentsByFileToUpload => {
  return Object.fromEntries(
    Object.entries(member)
      .map(([key, field]) => [key, field?.value])
      .filter(([, value]) => value !== undefined)
  ) as IDependentsByFileToUpload;
};
